import React, { Component } from "react";
import { Tabs, Upload, Form, Spin, message } from "antd";
import "./Documents.scss";
import {
  FaCloudUploadAlt,
  FaDownload,
  FaEye,
  FaFilePdf,
  FaTimes,
} from "react-icons/fa";
import { connect } from "react-redux";
import { UploadFinancingRequestFile } from "../../network/profile.network";
import { GetFinancingRequestDetails } from "../../network/customer.network";
import { deleteDoc } from "../../network/request.network";
import { setUserRequest } from "../../redux/user/user.action";
import DeleteModal from "../DeleteModal/DeleteModal";

const { TabPane } = Tabs;

class Documents extends Component {
  state = {
    tableLoading: false,
    showDltModal: false,
    FinancingRequestDetails: null,
    FinanceRequestFiles: [],
    FinanceRequestFilesNotUploaded: [],
    FinanceRequestFilesUploaded: [],
  };

  componentDidMount() {
    this.handelGetFinancingRequestDetails();
  }

  handelGetFinancingRequestDetails = () => {
    const { userRequest } = this.props;
    this.setState({ tableLoading: true });
    GetFinancingRequestDetails(
      userRequest?.Id,
      (res) => {
        // const FileTypesWithoutUpload = this.props.FileTypes?.filter(ele => )
        this.setState(
          {
            FinancingRequestDetails: res.data.model,
            FinanceRequestFiles: res.data.model.FinanceRequestFiles,
          },
          () => {
            this.handelAllFileUploadOrNot();
          }
        );
        this.props.dispatch(setUserRequest(res.data.model));
      },
      (err) => {
        this.setState({ tableLoading: false });
      }
    );
  };

  handelAllFileUploadOrNot = () => {
    const { FinanceRequestFiles } = this.state;
    const { FileTypes } = this.props;
    // console.log(FileTypes, "FileTypes")
    // console.log(FinanceRequestFiles, "FinanceRequestFiles")
    if (FileTypes) {
      this.setState({ tableLoading: false });
      let result = FileTypes.filter(
        (o1) => !FinanceRequestFiles.some((o2) => o1.Id === o2?.FileType?.Id)
      );
      this.setState({
        FinanceRequestFilesNotUploaded: result,
        FinanceRequestFilesUploaded: FinanceRequestFiles,
      });
      // console.log(result, "resultresultresult")
    } else {
      setTimeout(() => {
        this.handelAllFileUploadOrNot();
      }, 1000);
    }
  };

  handelChangeImg = (data, fileType) => {
    const { userRequest } = this.props;
    this.setState({ tableLoading: true });
    let body = new FormData();
    body.append("FileTypeId", fileType.Id);
    body.append("FinancingRequestId", userRequest?.Id);
    body.append("File", data.file);
    UploadFinancingRequestFile(
      body,
      (res) => {
        message.success("تمت إضافة المستند بنجاح");
        this.setState(
          {
            tableLoading: false,
            FinanceRequestFiles: [
              ...this.state.FinanceRequestFiles,
              res.data.model,
            ],
          },
          () => {
            this.handelAllFileUploadOrNot();
          }
        );
      },
      (error) => {
        this.setState({ tableLoading: false });

        message.error("حدث خطأ أثناء معالجة المستند");
      }
    );
  };

  handeldeleteDoc = () => {
    const { docDltId } = this.state;
    deleteDoc(
      docDltId?.Id,
      (res) => {
        message.success("تم حذف المستند بنجاح");
        this.setState(
          {
            FinanceRequestFiles: this.state.FinanceRequestFiles.filter(
              (ele) => ele?.Id !== docDltId?.Id
            ),
          },
          () => {
            this.handelAllFileUploadOrNot();
          }
        );
      },
      (error) => {
        this.setState({ loading: false });
        // console.log(error);
      }
    );
  };

  closeDltModal = () => {
    this.setState({ showDltModal: false });
  };

  render() {
    const {
      tableLoading,
      showDltModal,
      FinanceRequestFilesNotUploaded,
      FinanceRequestFilesUploaded,
    } = this.state;

    return (
      <div className="finance-tab-content cocuments-page">
        {showDltModal && (
          <DeleteModal
            delete={this.handeldeleteDoc}
            name="المستند"
            closeDltModal={this.closeDltModal}
          />
        )}
        <h2 className="tab-title">المستندات</h2>
        <div className="calc-tabs">
          <Form
            className="form-add-content"
            layout="vertical"
            name="nest-messages"
            onFinish={this.props.submitForm}
            id="orderForm"
          >
            <Spin spinning={tableLoading}>
              <Tabs defaultActiveKey="1">
                <TabPane tab="العميل" key="1">
                  <div className="form-content pt-30 grid-perc">
                    {FinanceRequestFilesUploaded?.filter(
                      (file) => file?.FileType?.IsCustomerFile === true
                    )?.map((doc) => (
                      <div className="docs-holder" key={doc.Id}>
                        <h6 className="docs-title">{doc?.FileType?.NameLT}</h6>
                        <div className="doc-body">
                          <div className="browse-file-content">
                            <FaFilePdf />
                            <div className="browse-file-text">
                              <p>
                                {doc?.FileType?.MimeType?.replace(
                                  "application/",
                                  " "
                                ).replace("image/", " ")}
                              </p>
                              {/* <span>120.kb</span> */}
                            </div>
                          </div>
                          <div className="doc-action">
                            <a href={doc.Path} target="_blank">
                              <FaEye style={{ color: "#f4cc26" }} />
                            </a>
                            <a href={doc.Path} target="_blank">
                              <FaDownload
                                style={{ color: "#0c74c2", margin: "0 14px" }}
                              />
                            </a>
                            <FaTimes
                              style={{ color: "#cc3524" }}
                              onClick={() =>
                                this.setState({
                                  showDltModal: true,
                                  docDltId: doc,
                                })
                              }
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                    {FinanceRequestFilesNotUploaded?.filter(
                      (file) => file.IsCustomerFile === true
                    ).map((file) => (
                      <Form.Item
                        label={file.NameLT}
                        name={file.Id}
                        className="input-holder"
                        rules={[
                          {
                            required: !file.IsOptional,
                          },
                        ]}
                      >
                        <Upload
                          // listType="picture"
                          accept={file.MimeType}
                          maxCount={1}
                          // beforeUpload={() => false}
                          onChange={(data) => this.handelChangeImg(data, file)}
                          showUploadList={false}
                          beforeUpload={(data) => {
                            const reader = new FileReader();
                            reader.onload = (e) => {
                              //console.log(data, "sadfsd")
                            };
                            return false;
                          }}
                        >
                          <div className="btn-upload">
                            <div className="upload-btn-holder">
                              <div className="browse-file-content">
                                <FaCloudUploadAlt />
                                <div className="browse-file-text">
                                  <p>قم بإسقاط الملفات هنا </p>
                                  <span>
                                    (
                                    {file?.MimeType?.replace(
                                      "application/",
                                      " "
                                    ).replace("image/", " ")}
                                    )
                                  </span>
                                </div>
                              </div>
                              <h5 className="browse-file-p">أو تصفح الملفات</h5>
                            </div>
                          </div>
                        </Upload>
                      </Form.Item>
                    ))}
                  </div>
                </TabPane>
              </Tabs>
            </Spin>
          </Form>
        </div>

        {/* <Form
          className="form-add-content"
          layout="vertical"
          name="nest-messages"
          onFinish={this.props.submitForm}
              id="orderForm"
              style={{ "display" : "none" }}
        >
          <div className="form-content">
          <Form.Item
            label="التعريف بالراتب"
            name="Salarydefinition"
            className="input-holder"
              rules={[
                {
                  required: true,
                },
              ]}
          >
            <Upload
              listType="picture"
              defaultFileList={[...fileList]}
            >
              <div className="btn-upload">
                <div className="upload-btn-holder">
                  <div className="browse-file-content">
                    <FaCloudUploadAlt />
                    <div className="browse-file-text">
                      <p>قم بإسقاط الملفات هنا </p>
                      <span>(pdf, jpg.ملف )</span>
                    </div>
                  </div>
                  <h5 className="browse-file-p">أو تصفح الملفات</h5>
                </div>
              </div>
            </Upload>
          </Form.Item>
          <Form.Item
            label="هويه العميل"
            name="CustomerID"
            className="input-holder"
              rules={[
                {
                  required: true,
                },
              ]}
          >
            <Upload
              listType="picture"
              // defaultFileList={[...fileList]}
            >
              <div className="btn-upload">
                <div className="upload-btn-holder">
                  <div className="browse-file-content">
                    <FaCloudUploadAlt />
                    <div className="browse-file-text">
                      <p>قم بإسقاط الملفات هنا </p>
                      <span>(pdf, jpg.ملف )</span>
                    </div>
                  </div>
                  <h5 className="browse-file-p">أو تصفح الملفات</h5>
                </div>
              </div>
            </Upload>
          </Form.Item>
          {uploadFile.map(file => 
                      <Form.Item
                      label={`${file.name}`}
                      name={`${file.id}`}
                      className="input-holder"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                    >
                      <Upload
                        listType="picture"
                        // defaultFileList={[...fileList]}
                      >
                        <div className="btn-upload">
                          <div className="upload-btn-holder">
                            <div className="browse-file-content">
                              <FaCloudUploadAlt />
                              <div className="browse-file-text">
                                <p>قم بإسقاط الملفات هنا </p>
                                <span>(pdf, jpg.ملف )</span>
                              </div>
                            </div>
                            <h5 className="browse-file-p">أو تصفح الملفات</h5>
                          </div>
                        </div>
                      </Upload>
                    </Form.Item>
                    )}
          </div>
        </Form> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  FileTypes: state.user.metaData.FileTypes,
  userRequest: state.user.userRequest,
});
export default connect(mapStateToProps)(Documents);
